// extracted by mini-css-extract-plugin
export default {"root":"ListingNumberMatch_root__aECjY","text":"ListingNumberMatch_text__-FJh2"};